<template>
  <Transition
      enter-class="opacity-0"
      enter-to-class="opacity-100"
      leave-class="opacity-100"
      leave-to-class="opacity-0"
  >
  <div class="duration-300 ease-in-out transition-opacity fixed bottom-0 inset-x-0 inset-y-0 px-4 py-6 sm:inset-0 sm:p-0 sm:flex sm:items-center sm:justify-center z-20" v-show="hasMounted">
    <!--
      Background overlay, show/hide based on modal state.

      Entering: "ease-out duration-200"
        From: "opacity-0"
        To: "opacity-100"
      Leaving: "ease-in duration-200"
        From: "opacity-100"
        To: "opacity-0"
    -->
    <Transition
      enter-class="opacity-0"
      enter-to-class="opacity-100"
      leave-class="opacity-100"
      leave-to-class="opacity-0"
    >
      <div class="ease-out duration-300 fixed inset-0 transition-opacity">
        <div class="absolute inset-0 bg-gray-500 opacity-75" @click="finished"></div>
      </div>
    </Transition>
    <!--
      Modal panel, show/hide based on modal state.

      Entering: "ease-out duration-200"
        From: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
        To: "opacity-100 translate-y-0 sm:scale-100"
      Leaving: "ease-in duration-200"
        From: "opacity-100 translate-y-0 sm:scale-100"
        To: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
    -->
    <Transition
      enter-class="sm:opacity-0 translate-y-full sm:translate-y-0 sm:scale-95"
      enter-active-class="ease-out duration-300"
      enter-to-class="sm:opacity-100 translate-y-0 sm:scale-100"
      leave-class="sm:opacity-100 translate-y-0 sm:scale-100"
      leave-active-class="ease-in duration-300"
      leave-to-class="sm:opacity-0 translate-y-full sm:translate-y-0 sm:scale-95"
    >

      <div class="bg-white rounded-lg overflow-hidden shadow-xl transform transition-all sm:max-w-lg sm:w-full fixed inset-x-4 sm:inset-auto bottom-4 max-h-90 flex flex-col max-h-75pct" role="dialog" aria-modal="true" aria-labelledby="modal-headline" v-show="hasMounted">
        <Mutation
          :mutation="mutation"
          :variables="variables"
          @done="onDone"
          @error="onError"
        >

        <template v-slot="{ mutate, loading }">
          <ValidationObserver
            ref="observer"
            v-slot="{ valid, invalid }"
            tag="form"
            @submit.prevent="mutate"
          >

          <div class="flex-shrink overflow-y-auto bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
            <div class="sm:flex sm:items-start">
              <div class="sm:mt-0 sm:text-left w-full">
                <div class="">
                  <div class="flex justify-between">
                    <label for="proposedLabel" class="block text-sm font-medium leading-5 text-gray-700">Label</label>
                    <span class="text-sm leading-5 text-gray-500" id="proposedLabel-optional">Optional</span>
                  </div>
                  <div class="mt-1 relative rounded-md shadow-sm">
                    <input id="proposedLabel" class="form-input block w-full sm:text-sm sm:leading-5" placeholder="Mrs. Bose" aria-describedby="proposedLabel-optional" v-model="proposedLabel" />
                  </div>
                </div>
                <div class="mt-6">
                  <label for="proposedHomeLanguage" class="block text-sm font-medium leading-5 text-gray-700">
                    Home Language
                  </label>
                  <div class="mt-1 rounded-md shadow-sm">
                    <select id="proposedHomeLanguage" class="form-select block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5" v-model="proposedHomeLanguage">
                      <option v-for="homeLanguage in homeLanguages" :value="homeLanguage" :key="homeLanguage.id">
                        {{homeLanguage.name}}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="mt-6">
                  <label for="proposedStudents" class="block text-sm font-medium leading-5 text-gray-700">
                    Attached Students
                  </label>
                  <SelectDropdown
                    :possibleItems="students"
                    :textFunction="studentFirstLast"
                    :search="true"
                    :multiple="true"
                    :showComboSelections="false"
                    show-list-selections
                    v-model="proposedStudents"
                    class="min-h-48"
                  >
                    <span slot="selection-format" slot-scope="{selection}">
                      {{studentFirstLast(selection)}}
                    </span>
                  </SelectDropdown>
                </div>
              </div>
            </div>
          </div>
          <div class="bg-gray-50 px-4 py-3 sm:px-6 flex-shrink-0 sm:flex sm:flex-row-reverse">
            <span class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
              <button type="submit" class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-indigo-600 text-base leading-6 font-medium text-white shadow-sm hover:bg-indigo-500 focus:outline-none focus:border-indigo-700 focus:ring-indigo transition ease-in-out duration-150 sm:text-sm sm:leading-5">
                Save
              </button>
            </span>
            <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
              <button type="button" class="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:ring-blue transition ease-in-out duration-150 sm:text-sm sm:leading-5" @click="finished">
                Cancel
              </button>
            </span>
          </div>

            </ValidationObserver>

          </template>

        </Mutation>
      </div>
    </Transition>

  </div>
  </Transition>
</template>


<script>
import _get                                       from 'lodash-es/get'
import _map                                       from 'lodash-es/map'
import { tz }                                     from '@/tz'

import Mutation                                   from '@/components/Mutation.vue'
import SelectDropdown                             from '@/components/SelectDropdown.vue'

import HomeNumberUpdateMutation                   from '@/mutations/HomeNumberUpdate.gql'
import { ValidationObserver, ValidationProvider } from "vee-validate";

export default {
  components: {
    Mutation,
    SelectDropdown,
    ValidationObserver
  },

  props: {
    canGoBack: {
      type: Boolean,
      default: false
    },

    homeNumber: {
      type: Object,
      required: true
    },

    homeNumberId: {
      type: String,
      required: true
    },

    teamId: {
      type: String,
      required: true
    },

    students: {
      type: Array,
      required: true
    },

    homeLanguages: {
      type: Array,
      required: true
    }
  },

  data() {
    return {
      proposedLabel: undefined,
      proposedHomeLanguage: undefined,
      proposedStudents: [],
      isValid: true,
      isSubmitting: false,
      mutation: HomeNumberUpdateMutation,
      hasMounted: !(this.canGoBack == true)
    }
  },

  mounted() {
    this.hasMounted = true
    this.proposedLabel = this.homeNumber.label
    this.proposedHomeLanguage = this.homeNumber.homeLanguage
    this.proposedStudents = this.homeNumber.students
  },

  beforeRouteLeave(to, from, next) {
    this.hasMounted = false
    next()
  },

  computed: {
    canProposeStudents () {
      if (this.students.length) {
        return this.students.length > 0
      } else {
        return false
      }
    },

    proposedStudentIds() {
      return _map(this.proposedStudents, 'id')
    },

    variables() {
      return {
        homeLanguageId: _get(this.proposedHomeLanguage, 'id'),
        id: this.homeNumberId,
        label: this.proposedLabel,
        studentIds: this.proposedStudentIds,
        tz: tz()
      }
    },
  },

  methods: {
    onDone() {
      Bus.$emit('flash-message', {text: 'Home number updated', type: 'success'})
        this.$router.push({name: 'homeNumber'})
    },

    onError(e) {
      Bus.$emit('flash-message', {text: e, type: 'error'})
    },

    finished() {
      this.canGoBack ? this.$router.go(-1) : this.$router.push({name: 'homeNumber'})
    },

    studentFirstLast: function (student) {
      return student.last + ', ' + student.first
    },
  }
}
</script>
